// extracted by mini-css-extract-plugin
module.exports = {"timer":"ActionTime_timer__31pIV","timerLabel":"ActionTime_timerLabel__2ikR_","countdown":"ActionTime_countdown__1pQR3","textBold":"ActionTime_textBold__1QvkY"};